import React, {useEffect, useMemo, useRef, useState} from 'react'
import './styles.css'

const Accordion = ({
                    type = 'single', //single,multiple
                    defaultValue = null,
                    value = null,
                    onTriggerClick = null,
                    children,
                    className = '',
                    style = null
                   }) => {

    const [internalValue, setInternalValue] = useState(defaultValue);
    const containerRef = useRef(null);

    const computedValue = useMemo(() => {
        return value ? value : internalValue;
    },[internalValue,value]);


    useEffect(() => {
        let accordionItems;
        if (containerRef.current) {
            accordionItems = containerRef.current.querySelectorAll('.accordion-item');

            if(defaultValue) {
                const toOpen = Array.isArray(defaultValue) ? defaultValue : [defaultValue];

                accordionItems.forEach(item => {
                    if(toOpen.includes(item.id.replace('accordion-item-', ''))) {
                        item.classList.add(`open`);
                    }
                })
            }

        }

    },[])

    const firstRender = useRef(false);

    useEffect(() => {

        if(!firstRender.current) {
            firstRender.current = true;
            return;
        }

        if (containerRef.current) {
            const accordionItems = containerRef.current.querySelectorAll('.accordion-item');

            const toOpen = Array.isArray(computedValue) ? computedValue : [computedValue];

            accordionItems.forEach(item => {
                if (toOpen.includes(item.id.replace('accordion-item-', ''))) {
                    item.classList.add(`open`);
                } else {
                    item.classList.remove(`open`);
                }
            })

        }
    },[computedValue]);

    function handleTriggerClick(val) {

        if(onTriggerClick){
            onTriggerClick(val)
        }

        if(type === 'single') {
            if(internalValue === val) {
                setInternalValue(null)
            }else{
                setInternalValue(val)
            }
        }else{

            if(!internalValue){
                setInternalValue([val])
                return
            }

            const index = internalValue.indexOf(val);

            if (index === -1) {
                setInternalValue([...internalValue, val]);
            } else {
                setInternalValue(internalValue.filter(item => item !== val));
            }

        }

    }

    function injectClickHandlers(element) {
        if (!React.isValidElement(element)) return element;

            const val = element.props.value;

            return React.cloneElement(element, {
                ...element.props,
                onTriggerClick: () => handleTriggerClick(val),
                isOpen: () => computedValue && (computedValue === val ||  computedValue.includes(val)),
            });

    }

    return (
        <React.Fragment>
            <div ref={containerRef} className={'accordion ' + className} style={style}>
                {React.Children.map(children, injectClickHandlers)}
            </div>
        </React.Fragment>
    )
}

export default Accordion;


// WEBPACK FOOTER //
// ./src/components-new/ui/Accordion/index.jsx